import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

type MetricTone = 'blue' | 'green' | 'purple' | 'indigo' | 'yellow' | 'orange' | 'red' | 'gray';

const toneClasses: Record<MetricTone, string> = {
  blue: 'bg-blue-50 text-blue-600',
  green: 'bg-green-50 text-green-600',
  purple: 'bg-violet-50 text-violet-600',
  indigo: 'bg-indigo-50 text-indigo-600',
  yellow: 'bg-amber-50 text-amber-600',
  orange: 'bg-orange-50 text-orange-600',
  red: 'bg-red-50 text-red-600',
  gray: 'bg-gray-100 text-gray-600',
};

export interface MetricCardProps {
  title: string;
  value: number | string;
  icon?: ReactNode;
  tone?: MetricTone;
  trendLabel?: string;
  tag?: string;
  className?: string;
}

export default function MetricCard({
  title,
  value,
  icon,
  tone = 'blue',
  trendLabel,
  tag,
  className,
}: MetricCardProps) {
  return (
    <article className={cn('rounded-xl border border-gray-200 bg-white p-5 shadow-sm', className)}>
      <div className="mb-4 flex items-center justify-between gap-3">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        {icon && (
          <span className={cn('inline-flex h-10 w-10 items-center justify-center rounded-full text-lg', toneClasses[tone])}>
            {icon}
          </span>
        )}
      </div>

      <p className="text-3xl font-bold text-gray-900">{value}</p>

      {(trendLabel || tag) && (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {trendLabel && <p className="text-xs font-medium text-gray-500">{trendLabel}</p>}
          {tag && (
            <span className="rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
              {tag}
            </span>
          )}
        </div>
      )}
    </article>
  );
}
